import type { Exercise } from '@jackedlogs/shared';

// Per-side logging hint for handheld (dumbbell / kettlebell) work, Antenore
// 2026-06-19 (inbox 109b3585: "we should clarify when to log per side").
//
// CONVENTION (SL logic): for two-implement / single-side handheld work you log
// the weight of ONE implement and the app counts both sides (×2 via the
// unilateral flag). So the hint fires exactly when the exercise is handheld AND
// flagged unilateral — covers both genuine single-arm lifts and two-dumbbell
// work (each hand holds one implement). A single implement held two-handed
// (goblet squat, two-hand pullover) is bilateral ×1 and needs no clarification:
// the entered weight already IS the total.
//
// Pure (equipment + unilateral only) so it's RNW-portable and unit-testable.
export function showsPerImplementHint(
  exercise: Pick<Exercise, 'equipment' | 'unilateral'>,
): boolean {
  const handheld =
    exercise.equipment === 'dumbbell' || exercise.equipment === 'kettlebell';
  return handheld && exercise.unilateral === true;
}
